export default "__VITE_ASSET__cK$xpyAj__"